module.exports = __webpack_public_path__ + "img/welcome1.f89c39f7.jpg";